import { Fragment } from "react";
import { siteData } from "@/lib/aht/pageData";
import { needsVerify, val } from "@/lib/aht/format";

// Wraps a value. While meta.isDraft is true, values marked verify: true get a dashed underline.
export function V({ item, children, className = "" }) {
  const show = siteData.meta.isDraft && needsVerify(item);
  return (
    <span className={`${show ? "verify-mark" : ""} ${className}`} data-verify={show ? "true" : undefined}>
      {children !== undefined ? children : val(item)}
    </span>
  );
}

// Like fill(), but tokens can be React nodes (e.g. a <V> value).
export function fillJsx(tpl, vars = {}) {
  return String(tpl)
    .split(/(\{\w+\})/g)
    .map((part, i) => {
      const m = part.match(/^\{(\w+)\}$/);
      return <Fragment key={i}>{m ? vars[m[1]] : part}</Fragment>;
    });
}
